<p-menu #langSwitchMenu [popup]="true" [model]="menuItems" styleClass="w-24" appendTo="body"></p-menu>

<div *transloco="let t" (click)="langSwitchMenu.toggle($event)" pRipple class="inline-block float-right px-3 py-3 pr-5 mt-3 cursor-pointer">
    <span class="absolute right-0 inline-block text-xs mt-3px icon-chevronDown-outline"></span>
    <p>{{ t("lang_display") }}</p>
</div>
